// 토스페이먼츠 테스트 키값들
export const TOSS_PAYMENTS_CONFIG = {
  CLIENT_KEY: process.env.REACT_APP_TOSS_CLIENT_KEY,
  SECRET_KEY: process.env.REACT_APP_TOSS_SECRET_KEY,
  SECURITY_KEY: process.env.REACT_APP_TOSS_SECURITY_KEY,
  BASE_URL: process.env.REACT_APP_TOSS_BASE_URL,
};
